<template>
  <FormValidation class="FormTagsSelectable" @submit="addTag">
    <FieldLabel :label="label" />

    <div class="tagsList">
      <TagRemovable
        v-for="(tag, index) in tags"
        :key="index"
        class="lg"
        :label="tag"
        @remove="removeTag(index)" />
    </div>

    <Row>
      <Column :sm="8">
        <Field
          class="lg"
          :value.sync="tagCurrent" />
      </Column>
      <Column :sm="4">
        <Btn class="success" type="submit">
          {{ $t('add') }}
        </Btn>
      </Column>
    </Row>
  </FormValidation>
</template>

<script>
import TagRemovable from '@components/TagRemovable'

export default {
  components: { TagRemovable },
  props: {
    tags: Array,
    label: String,
  },
  data() {
    return {
      tagCurrent: null,
    }
  },
  methods: {
    addTag() {
      this.tags.push(this.tagCurrent)
      this.tagCurrent = null
    },
    removeTag(index) {
      this.tags.splice(index, 1)
    },
  },
}
</script>

<style lang="scss">
.FormTagsSelectable {
  .tagsList {
    display: block;
    margin-bottom: $grid-unit;

    > .Tag {
      margin: 0 0.5rem 0.5rem 0;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "add": "Add"
  }
}
</i18n>
